// 海外版（Global）配置清单。
//
// REST API 在新加坡（api.cloud.cgaapp.com）；GS 游戏池在香港；TURN 中继同在香港
// 接入层 129.226.193.105（新加坡）。这些值可被 .env.global 覆盖。

import type { EditionConfig } from "../types";

export const edition: EditionConfig = {
  region: "global",

  review: {
    enabled: import.meta.env.VITE_REVIEW_MODE === "true",
    serverHost: import.meta.env.VITE_REVIEW_SERVER_HOST ?? "82.156.112.94",
    serverPort: Number(import.meta.env.VITE_REVIEW_SERVER_PORT ?? 9000),
    gameId: Number(import.meta.env.VITE_REVIEW_GAME_ID ?? 111222),
    opToken: import.meta.env.VITE_REVIEW_OP_TOKEN ?? "12345",
    turnHost: import.meta.env.VITE_REVIEW_TURN_HOST ?? "129.226.193.105",
  },

  api: {
    // 新加坡 REST API 走「同源反代」免 CORS：dev=vite proxy(/api→cgaapp)，prod=香港 nginx。
    // 故 baseUrl 留空走相对 /api；如需前端直连绝对地址，填 .env.global 的 VITE_API_BASE_URL。
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
    appId: import.meta.env.VITE_APP_ID ?? "com.cga.cloudgame.platform",
    channel: import.meta.env.VITE_APP_CHANNEL ?? "web",
    versionCode: String(import.meta.env.VITE_VERSION_CODE ?? "260427001"),
  },

  // 海外：游客 + Google + Facebook。
  // （当前数组只是声明，未接线；第 3 步 LoginForm 改成遍历 authMethods 时生效。）
  authMethods: ["guest", "google", "telegram", "facebook"],

  oauth: {
    // Google Cloud Console「Web application」客户端 id；建好后填进 .env.global
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
    // BotFather → Login Widget 中的 Client ID；这是公开配置，不是 Bot Token/Secret。
    telegramClientId: import.meta.env.VITE_TELEGRAM_CLIENT_ID ?? "",
  },

  payment: {
    channel: "intl",
    plans: [
      {
        id: "vip_month",
        level: "vip",
        nameKey: "subscription.planVipMonth",
        price: "$4.99",
        perDayPrice: "$0.16",
        perkKeys: [
          "subscription.perkNoQueue",
          "subscription.perkDailyFree",
          "subscription.perkHd",
        ],
        color: "from-blue-500/30 to-blue-700/10",
      },
      {
        id: "svip_month",
        level: "svip",
        nameKey: "subscription.planSvipMonth",
        price: "$9.99",
        perDayPrice: "$0.33",
        perkKeys: [
          "subscription.perkAllVip",
          "subscription.perkUnlimited",
          "subscription.perk4k",
          "subscription.perkSupport",
        ],
        color: "from-amber-500/30 to-rose-700/10",
        recommended: true,
      },
    ],
  },

  ui: {
    defaultLocale: "en", // 浏览器语言探测失败时回退英文
    // 顺序 = 选择器展示顺序，按活跃用户数从高到低排列
    locales: ["en", "id", "vi", "th", "ms", "hi", "zh", "zh-TW", "bn", "tl"],
    density: "comfortable",
    loginSubtitleKey: "login.subtitleGlobal",
    brandKey: "common.appNameGlobal",
    // 英文名长：列表用横向条目（左方图+名称/简介/评分，类 SVIP 卡，名称折 2 行完整展示）
    // + 分类用顶部横向胶囊；poster 场景（首页横滑等）标题也折 2 行
    listLayout: { itemStyle: "row", gridCols: 2, titleLines: 2, categoryNav: "chips" },
  },

  streaming: {
    turnHost: "129.226.193.105", // 新加坡海外生产接入层
  },
};

export default edition;
